import Link from 'next/link'
import React, { memo } from 'react'

import CustomImage from '@/components/elements/images/image'

const contactCards = ({ cards }) =>
  cards.map(card => (
    <Link href={card.href} key={card.id}>
      <a className="contact-card-links" target="_blank" rel="noopener noreferrer">
        <div className="contact-card-container">
          <div className="contact-card-image-container">
            <div className="contact-card-images">
              <CustomImage
                media={card.image.data.attributes}
                layout="fill"
                objectFit="contain"
              />
            </div>
            <div className="contact-card-title">{card.title}</div>
          </div>
          <div className="contact-card-content">{card.content}</div>
        </div>
      </a>
    </Link>
  ))

export default memo(contactCards)
